<template>
    <v-flex class="notifications" :url="url">
        <h2 :class=" $store.state.isNew ? 'notifications_point new' : 'notifications_point'"
            style="cursor: pointer"
            @click="$store.state.isNew = !$store.state.isNew"
        >{{ $t('новые') }}</h2>
        <Transition name="bounce">
            <div v-if="$store.state.isNew">
                <div v-if="notifications.filter((x) => x.new) != ''">
                    <notificationRecord v-for="(notification, i) in notifications.filter((x) => x.new).splice(0, 10)" :key="i" class="notifications_block"
                                        :info="notification"
                    />
                </div>
                <h2 v-else class="section-title mt-3 ml-0"> Новых уведомлений нет</h2>
            </div>
        </Transition>
    </v-flex>
</template>

<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import notificationRecord from '@/components/blocks/Notifications/notification_record.vue';

export default {
  components: {
    notificationRecord,
  },
  watch: {
    /* new_notes_id() {
      if (this.new_notes_id.length > 0) {
        this.set_read_notes(this.new_notes_id);
      }
    },*/
  },
  methods: {
    ...mapMutations('notifications/Notifications_items', [
      'SET_READ_MESSAGE',
    ]),
    ...mapActions('notifications/Notifications_items', [
      'set_read_notes',
    ]),
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
    ...mapGetters('notifications/Notifications_items', [
      'notifications',
    ]),
    new_notes() {
      return this.notifications.filter((x) => x.new);
    },
    new_notes_id() {
      let ids = this.new_notes.map((item) => item.notification_id);

      return ids;
    },
  },
};
</script>
